import { render, staticRenderFns } from "./EventTypeBadge.vue?vue&type=template&id=3fb53be6&scoped=true&"
import script from "./EventTypeBadge.vue?vue&type=script&lang=ts&"
export * from "./EventTypeBadge.vue?vue&type=script&lang=ts&"
import style0 from "./EventTypeBadge.vue?vue&type=style&index=0&id=3fb53be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb53be6",
  null
  
)

export default component.exports